/**
 * Where to land after switching tenant: the same section, not the page of a
 * single object and without the page parameters — those belong to the
 * previous tenant (a CI, a job, the device chosen on the Network page) and
 * do not exist in the new one. Home when the new tenant does not have the
 * section (licence or role), as before: that check runs after the reload, in
 * the layout, with the same rules as the menu (`DOPO_CAMBIO_TENANT`).
 */

/** Session flag: the page was just reloaded by a tenant switch. */
export const DOPO_CAMBIO_TENANT = 'censo.dopoCambioTenant'

/** The console's section paths (App.tsx routes without parameters). Keep in
 *  sync when a section is added: a missing one just lands on its parent. */
const SEZIONI = new Set([
  'dobermann', 'honeypot', 'guide', 'nis2', 'dora', 'cra', 'cis', 'assets', 'contracts', 'suppliers', 'suppliers/list', 'suppliers/catalog', 'suppliers/ict', 'suppliers/requests', 'reports', 'usage',
  'scan-stats', 'network', 'firmware', 'topology', 'virtual-map', 'vinventory', 'cloud-map', 'master-data', 'eagle',
  'eagle/cis', 'eagle/sonde', 'eagle/notifiche', 'eagle/report', 'eagle/profili', 'eagle/parete', 'eagle/cruscotti', 'cinventory', 'container-inventory', 'cost-center', 'software-flow', 'plaintext-traffic', 'encryption', 'encryption/certificates', 'certificates', 'bitlocker', 'addresses', 'software-map', 'business-apps', 'software-list', 'software-eol', 'software-licenses', 'software-supply', 'tags', 'dns',
  'backup', 'ipam', 'awx', 'capacity', 'flows', 'presence', 'flows/entry-points', 'flows/exporters', 'flows/analysis',
  'flows/map', 'routing', 'security-health', 'ai-usage', 'patching', 'wazuh', 'cynet', 'firewall', 'services', 'fleet', 'probe-groups', 'users', 'api-keys',
  'pools', 'device-configs', 'inventory-agents', 'discovery-plans', 'jobs', 'schedules', 'credentials',
  'integrations', 'connectors', 'settings', 'audit', 'taxonomy',
  'medical',
  'access',
])

/** The section a path belongs to: «/cis/<id>» → «/cis», «/backup/jobs/x/1» → «/backup». */
export function sezioneDi(pathname: string): string {
  const parti = pathname.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean)
  while (parti.length > 0) {
    if (SEZIONI.has(parti.join('/'))) return `/${parti.join('/')}`
    parti.pop()
  }
  return '/'
}
